import { Component, OnInit } from '@angular/core';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';

@Component({
  selector: 'neo-pagina-contacto',
  templateUrl: './pagina-contacto.component.html',
  styleUrls: ['./pagina-contacto.component.scss']
})
export class PaginaContactoComponent implements OnInit {


  constructor(
    private configTitulo: ConfigTituloPaginasService
  ) { }

  ngOnInit(): void {
    this.configTitulo.establecerTitulo('Contacto');
  }

}
